import { render, staticRenderFns } from "./NewSendMailAction.vue?vue&type=template&id=df886976&"
import script from "./NewSendMailAction.vue?vue&type=script&lang=js&"
export * from "./NewSendMailAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports